import { type Column } from '@tanstack/react-table';
import { CSSProperties } from 'react';

export function getCommonPinningStyles<TData>({
  column,
  withBorder = false,
  isDragging = false,
}: {
  column: Column<TData>;
  withBorder?: boolean;
  isDragging?: boolean;
  isServiceColumn?: boolean;
  isResizable?: boolean;
}): React.CSSProperties {
  const isPinned = column.getIsPinned();
  const isLastLeftPinnedColumn =
    isPinned === 'left' && column.getIsLastColumn('left');
  const isFirstRightPinnedColumn =
    isPinned === 'right' && column.getIsFirstColumn('right');

  const style: CSSProperties = {
    boxShadow: withBorder
      ? isLastLeftPinnedColumn
        ? '-4px 0 4px -4px hsl(var(--border)) inset'
        : isFirstRightPinnedColumn
          ? '4px 0 4px -4px hsl(var(--border)) inset'
          : undefined
      : undefined,
    left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
    right: isPinned === 'right' ? `${column.getAfter('right')}px` : undefined,
    opacity: isDragging ? 0.9 : 1,
    position: isPinned ? 'sticky' : 'relative',
    background: isDragging || isPinned ? 'hsl(var(--background))' : 'inherit',
    zIndex: isPinned || isDragging ? 1 : 0,
  };

  return style;
}
